import { lazy } from "react";

const Home = lazy(() => import("../Home/Home"));
const ModernHome = lazy(() => import("../Home/ModernHome/ModernHome"));

export const homeRoutes = (access, settings) => [
  {
    path: "/home",
    element: settings?.uiTemplate === "modern" ? ModernHome : Home,
    title: "dashboard",
    enabled: access.dashboardAccess,
  },
];
